export function isSessionCurrent(expiration: number) {
  return Date.now() < expiration;
}
